import React, { useEffect, useState } from "react";
import Header from "../Layouts/Header.jsx";
import Single from "./Single.jsx";
import Jodi from "./Jodi.jsx";
import Stake from "./Stake";
import HeaderSection from "./HeaderSection.jsx";
import DoublePatti from "./DoublePatti.jsx";
import TriplePatti from "./TriplePatti.jsx";
import SinglePatti from "./SinglePatti.jsx";
import { Tabs, Tab } from "@heroui/react";
import { useParams } from "react-router-dom";
import { getUserIP } from "../../helpers/getIP.js";

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/react";

import { Card, CardBody, Button } from "@heroui/react";
import { Spinner } from "@heroui/react";
// import { useBalance } from "../../contexts/BalanceContext.jsx";

const MAX_SELECTION_VALUE = {
  single: 10,
  jodi: 100,
  singlePatti: 120,
  doublePatti: 90,
  tripplePatti: 10,
};

let DIGITS_MAP = {
  single_open: [...Array(10).keys()].map(String),
  single_close: [...Array(10).keys()].map(String),
  singlePatti_open: [
    "127",
    "136",
    "145",
    "190",
    "235",
    "280",
    "370",
    "389",
    "460",
    "479",
    "569",
    "578",
    "128",
    "137",
    "146",
    "236",
    "245",
    "290",
    "380",
    "470",
    "489",
    "560",
    "579",
    "678",
    "129",
    "138",
    "147",
    "156",
    "237",
    "246",
    "345",
    "390",
    "480",
    "570",
    "589",
    "679",
    "120",
    "139",
    "148",
    "157",
    "238",
    "247",
    "256",
    "346",
    "490",
    "580",
    "670",
    "689",
    "130",
    "149",
    "158",
    "167",
    "239",
    "248",
    "257",
    "347",
    "356",
    "590",
    "680",
    "789",
    "140",
    "159",
    "168",
    "230",
    "249",
    "258",
    "267",
    "348",
    "357",
    "456",
    "690",
    "780",
    "123",
    "150",
    "169",
    "178",
    "240",
    "259",
    "268",
    "349",
    "358",
    "367",
    "457",
    "790",
    "124",
    "160",
    "179",
    "250",
    "269",
    "278",
    "340",
    "359",
    "368",
    "458",
    "467",
    "890",
    "125",
    "134",
    "170",
    "189",
    "260",
    "279",
    "350",
    "369",
    "378",
    "459",
    "468",
    "567",
    "126",
    "135",
    "180",
    "234",
    "270",
    "289",
    "360",
    "379",
    "450",
    "469",
    "478",
    "568",
  ],
  singlePatti_close: [
    "127",
    "136",
    "145",
    "190",
    "235",
    "280",
    "370",
    "389",
    "460",
    "479",
    "569",
    "578",
    "128",
    "137",
    "146",
    "236",
    "245",
    "290",
    "380",
    "470",
    "489",
    "560",
    "579",
    "678",
    "129",
    "138",
    "147",
    "156",
    "237",
    "246",
    "345",
    "390",
    "480",
    "570",
    "589",
    "679",
    "120",
    "139",
    "148",
    "157",
    "238",
    "247",
    "256",
    "346",
    "490",
    "580",
    "670",
    "689",
    "130",
    "149",
    "158",
    "167",
    "239",
    "248",
    "257",
    "347",
    "356",
    "590",
    "680",
    "789",
    "140",
    "159",
    "168",
    "230",
    "249",
    "258",
    "267",
    "348",
    "357",
    "456",
    "690",
    "780",
    "123",
    "150",
    "169",
    "178",
    "240",
    "259",
    "268",
    "349",
    "358",
    "367",
    "457",
    "790",
    "124",
    "160",
    "179",
    "250",
    "269",
    "278",
    "340",
    "359",
    "368",
    "458",
    "467",
    "890",
    "125",
    "134",
    "170",
    "189",
    "260",
    "279",
    "350",
    "369",
    "378",
    "459",
    "468",
    "567",
    "126",
    "135",
    "180",
    "234",
    "270",
    "289",
    "360",
    "379",
    "450",
    "469",
    "478",
    "568",
  ],

  doublePatti_open: [
    "118",
    "226",
    "244",
    "299",
    "334",
    "488",
    "550",
    "668",
    "677",
    "100",
    "119",
    "155",
    "227",
    "335",
    "344",
    "399",
    "588",
    "669",
    "110",
    "200",
    "228",
    "255",
    "336",
    "499",
    "660",
    "688",
    "778",
    "166",
    "229",
    "300",
    "337",
    "355",
    "445",
    "599",
    "779",
    "788",
    "112",
    "220",
    "266",
    "338",
    "400",
    "446",
    "455",
    "699",
    "770",
    "113",
    "122",
    "177",
    "339",
    "366",
    "447",
    "500",
    "799",
    "889",
    "114",
    "277",
    "330",
    "448",
    "466",
    "556",
    "600",
    "880",
    "899",
    "115",
    "133",
    "188",
    "223",
    "377",
    "449",
    "557",
    "566",
    "700",
    "116",
    "224",
    "233",
    "288",
    "440",
    "477",
    "558",
    "800",
    "990",
    "117",
    "144",
    "199",
    "225",
    "388",
    "559",
    "577",
    "667",
    "900",
  ],
  doublePatti_close: [
    "118",
    "226",
    "244",
    "299",
    "334",
    "488",
    "550",
    "668",
    "677",
    "100",
    "119",
    "155",
    "227",
    "335",
    "344",
    "399",
    "588",
    "669",
    "110",
    "200",
    "228",
    "255",
    "336",
    "499",
    "660",
    "688",
    "778",
    "166",
    "229",
    "300",
    "337",
    "355",
    "445",
    "599",
    "779",
    "788",
    "112",
    "220",
    "266",
    "338",
    "400",
    "446",
    "455",
    "699",
    "770",
    "113",
    "122",
    "177",
    "339",
    "366",
    "447",
    "500",
    "799",
    "889",
    "114",
    "277",
    "330",
    "448",
    "466",
    "556",
    "600",
    "880",
    "899",
    "115",
    "133",
    "188",
    "223",
    "377",
    "449",
    "557",
    "566",
    "700",
    "116",
    "224",
    "233",
    "288",
    "440",
    "477",
    "558",
    "800",
    "990",
    "117",
    "144",
    "199",
    "225",
    "388",
    "559",
    "577",
    "667",
    "900",
  ],
  tripplePatti_open: [
    "000",
    "111",
    "222",
    "333",
    "444",
    "555",
    "666",
    "777",
    "888",
    "999",
  ],
  tripplePatti_close: [
    "000",
    "111",
    "222",
    "333",
    "444",
    "555",
    "666",
    "777",
    "888",
    "999",
  ],

  jodi_open: Array.from({ length: 100 }, (_, i) =>
    i.toString().padStart(2, "0")
  ),
  jodi_close: Array.from({ length: 100 }, (_, i) =>
    i.toString().padStart(2, "0")
  ),
};

const GameDetailPage = () => {
  const [selectedTab, setSelectedTab] = useState("photos");
  let rawBetType = localStorage.getItem("betType");
  let betTypeIn =
    rawBetType === null || rawBetType === "null" ? "single" : rawBetType;
  const [betType, setBetType] = useState(betTypeIn);
  const [betTime, setBetTime] = useState("open");
  const [selectedDigits, setSelectedDigits] = useState([]);
  const [stakeInput, setStakeInput] = useState(0);
  const [betHistory, setBetHistory] = useState([]);
  const [digitOptions, setDigitOptions] = useState(DIGITS_MAP["single_open"]);
  const [randomCount, setRandomCount] = useState("");
  const [rateMap, setRateMap] = useState({});
  const [minMaxMap, setMinMaxMap] = useState({});
  const [betTypes, setBetTypes] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRate, setSelectedRate] = useState(null);
  const [selectedMinMax, setSelectedMinMax] = useState({});
  const [marketName, setMarketName] = useState("");
  const [markets, setMarkets] = useState([]);
  const [draw_date, setDrawDate] = useState("");
  const [openTime, setOpenTime] = useState("");
  const [closeTime, setCloseTime] = useState("");
  const [isOpenSuspend, setIsOpenSuspend] = useState(0);
  const [isCloseSuspend, setIsCloseSuspend] = useState(0);
  const [selectedMarketKey, setSelectedMarketKey] = useState("");
  const [customDigits, setCustomDigits] = useState("");
  const [betsLog, setBetsLog] = useState([]);
  const [selectedStake, setSelectedStake] = useState(0);
  // const { balance, updateBalance, updateExposure } = useBalance();
  const [guruSelected, setGuruSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [digitStakes, setDigitStakes] = useState({});

  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [lastSelectedDigit, setLastSelectedDigit] = useState("");

  const [modalMessage, setModalMessage] = useState("");
  const openModalWithMessage = (message) => {
    setModalMessage(message);
    onOpen();
  };

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    localStorage.setItem("betType", betType);
  }, [betType]);

  // const STORAGE_KEY = 'user_bet_history';
  // const [loaded, setLoaded] = useState(false);
  // useEffect(() => {
  //   const stored = localStorage.getItem(STORAGE_KEY);
  //   if (stored) {
  //     try {
  //       const parsed = JSON.parse(stored);
  //       setBetHistory(parsed);
  //     } catch (e) {
  //       console.error("Failed to parse stored history", e);
  //     }
  //   }
  //   setLoaded(true);
  // }, []);
  // useEffect(() => {
  //   if (loaded) {
  //     localStorage.setItem(STORAGE_KEY, JSON.stringify(betHistory));
  //   }
  // }, [betHistory, loaded]);
  // useEffect(() => {
  //   if (loaded) {
  //     localStorage.setItem(STORAGE_KEY, JSON.stringify(betHistory));
  //   }
  // }, [betHistory, loaded]);

  const { match_id } = useParams();

  const formatTimeTo12Hour = (time24) => {
    if (!time24) return "--";
    const [hour, minute] = time24.split(":");
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const formatDateToDDMMYYYY = (dateString) => {
    const date = new Date(dateString);
    return date
      .toLocaleDateString("en-GB", {
        timeZone: "Asia/Dubai",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-");
  };

  useEffect(() => {
    const getMatchDetails = async (e) => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
      const urlencoded = {
        matchId: match_id,
      };
      let requestOptions = {
        method: "GET",
        headers: headers,
        // body: JSON.stringify(urlencoded),
      };
      fetch(
        process.env.REACT_APP_API_HOST + "/match/" + match_id,
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.data) {
            // your existing logic remains unchanged
            setIsOpenSuspend(result.data[0].open_suspend.data[0]);
            setIsCloseSuspend(result.data[0].close_suspend.data[0]);

            if (
              result.data[0].open_suspend.data[0] === 1 &&
              result.data[0].close_suspend.data[0] === 1
            ) {
              setSelectedMarketKey("open");
              setBetType("single");
              setBetTime("open");
            } else if (result.data[0].open_suspend.data[0] === 1) {
              setSelectedMarketKey("close");
              setBetType("single");
              setBetTime("close");
            } else if (result.data[0].close_suspend.data[0] === 1) {
              setSelectedMarketKey("open");
              setBetType("single");
              setBetTime("open");
            } else {
              setSelectedMarketKey("open");
              setBetType("single");
              setBetTime("open");
            }

            // setDrawDate(formatDateToDDMMYYYY(result.data[0].draw_date));
            setDrawDate(result.data[0].draw_date);
            setOpenTime(result.data[0].open_time || "");
            setCloseTime(result.data[0].close_time || "");

            const RATE_MAP = {};
            const BET_TYPES = [];
            const MIN_MAX_MAP = {};

            const ICON_MAP = {
              single: "/icons/single.svg",
              jodi: "/icons/jodi.svg",
              singlePatti: "/icons/single-patti.svg",
              doublePatti: "/icons/double-patti.svg",
              tripplePatti: "/icons/triple patti.svg",
            };

            result.data.forEach((item) => {
              const originalType = item.type_name.toLowerCase();
              let key = "";

              if (originalType === "single") key = "single";
              else if (originalType === "jodi") key = "jodi";
              else if (originalType === "single patti") key = "singlePatti";
              else if (originalType === "double patti") key = "doublePatti";
              else if (originalType === "triple patti") key = "tripplePatti";
              else return;

              MIN_MAX_MAP[key] = {
                min_stake: item.min_stake,
                max_stake: item.max_stake,
              };
              RATE_MAP[key] = item.rate;
              // BET_TYPES.push({ key, label: item.type_name.toUpperCase() });
              BET_TYPES.push({
                key,
                label: item.type_name.toUpperCase(),
                icon: ICON_MAP[key] || "", // fallback empty string if not found
              });
            });
            setMarketName(result.data[0].match_name);
            setRateMap(RATE_MAP);
            setBetTypes(BET_TYPES);
            setSelectedRate(RATE_MAP[betType] || null);
            setMinMaxMap(MIN_MAX_MAP);
            setSelectedMinMax(MIN_MAX_MAP[betType] || {});
            setSelectedType(betType);

            const markert_values = [
              {
                key: "open",
                label:
                  " OPEN (" +
                  formatTimeTo12Hour(result.data[0].open_time) +
                  ")",
              },
              {
                key: "close",
                label:
                  " CLOSE (" +
                  formatTimeTo12Hour(result.data[0].close_time) +
                  ")",
              },
            ];

            setMarkets(markert_values);
          }
        })
        .catch((err) => {
          console.log("Error fetching match details:", err);
        });
    };

    getMatchDetails();
  }, []);

  useEffect(() => {
    const getUserBets = async (e) => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
      const urlencoded = {
        match_id: match_id,
        user_id: localStorage.getItem("uid"),
      };
      let requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(urlencoded),
      };
      fetch(process.env.REACT_APP_API_HOST + "/bet", requestOptions)
        .then(async (response) => {
          const result = await response.json();
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.data) {
            const groupedMap = new Map();
            const res = result.data;
            res.forEach((item) => {
              const key = `${item.id}-${item.time}`;
              if (!groupedMap.has(key)) {
                groupedMap.set(key, {
                  digitStakes: {},
                  rate: item.rate,
                  type: item.type_name,
                  time: item.time,
                });
              }
              groupedMap.get(key).digitStakes[item.digit] = parseFloat(
                item.stake
              );
            });
            const userBets = Array.from(groupedMap.values());
            setBetHistory(userBets);
          }
        })
        .catch((err) => {
          console.log("Error fetching events:", err);
        })
        .finally(() => {});
    };
    getUserBets();
  }, [match_id]);

  useEffect(() => {
    getUserBetsLog();
  }, []);

  const getUserBetsLog = async () => {
    const matchId = match_id;
    const userId = localStorage.getItem("uid");
    const token = localStorage.getItem("jwt");

    let headers = new Headers();
    headers.append("Authorization", "Bearer " + token);

    const url = `${process.env.REACT_APP_API_HOST}/bet/details?match_id=${matchId}&user_id=${userId}`;

    fetch(url, {
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          setBetsLog(result.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching user bets log:", err);
      });
  };

  const handleDigitToggle = (digit) => {
    // alert(digit);
    // setSelectedDigits((prev) =>
    //   prev.includes(digit) ? prev.filter((d) => d !== digit) : [...prev, digit]
    // );
    if (!selectedStake) {
      alert("Please select a Stake");
      return;
    }

    setLastSelectedDigit(digit);

    setDigitStakes((prev) => ({
      ...prev,
      [digit]: (prev[digit] || 0) + selectedStake,
    }));
  };

  const checkOpenCloseBet = () => {
    const [day, month, year] = draw_date.split("-");
    const formattedDate = `${year}-${month}-${day}`;
    const now = new Date();
    if (betTime === "open") {
      const openDateTime = new Date(`${formattedDate}T${openTime}`);
      if (now >= openDateTime) {
        return false;
      } else {
        return true;
      }
    }
    if (betTime === "close") {
      const closeDateTime = new Date(`${formattedDate}T${closeTime}`);
      if (now >= closeDateTime) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleCustomInput = (e) => {
    let input = e.target.value;
    input = input.replace(/[^0-9,]/g, "");
    if (input.startsWith(",")) {
      input = input.slice(1);
    }
    input = input.replace(/,+/g, ",");
    setCustomDigits(input);
  };

  function addMissingValues(sourceArray, compareArray) {
    compareArray.forEach((value) => {
      if (!sourceArray.includes(value)) {
        sourceArray.push(value);
      }
    });
  }

  const handleSubmit = async () => {
    if (!selectedStake) {
      // alert("please select stake amount");
      openModalWithMessage("Please select stake amount");
      return;
    }
    if (Object.keys(digitStakes).length <= 0) {
      // alert("please select digit(s)");
      openModalWithMessage("Please select digit(s)");
      return;
    }
    let customArray = [];
    let mergedArray = [];
    let customDigitsTo = "";
    if (customDigits.length > 0) {
      if (customDigits.endsWith(",")) {
        customDigitsTo = customDigits.slice(0, -1);
      } else {
        customDigitsTo = customDigits;
      }
      customArray = customDigitsTo.split(",").map((d) => d.trim());
      mergedArray = [...new Set([...selectedDigits, ...customArray])];
    } else {
      mergedArray = [...selectedDigits];
    }
    if (betType === "single") {
      const invalidNumbers = mergedArray.filter(
        (num) => Number(num) < 0 || Number(num) > 9 || isNaN(Number(num))
      );
      if (invalidNumbers.length > 0) {
        alert(`Please enter proper digit(s) between 0-9`);
        return;
      }
    }
    if (betType === "singlePatti" || betType === "doublePatti") {
      const invalidNumbers = mergedArray.filter(
        (num) => Number(num) < 100 || Number(num) > 999 || isNaN(Number(num))
      );
      if (invalidNumbers.length > 0) {
        alert(`Please enter proper digit(s) between 100-999`);
        return;
      }
    }
    if (betType === "tripplePatti") {
      const invalidNumbers = mergedArray.filter(
        (num) => !/^\d{3}$/.test(num) // must be exactly 3 digits (e.g. "000", "111", "999")
      );
      if (invalidNumbers.length > 0) {
        alert(`Please enter only 3-digit numbers for Triple Patti`);
        return;
      }
    }
    if (betType === "jodi") {
      const invalidNumbers = mergedArray.filter(
        (num) => !/^\d{2}$/.test(num) // must be exactly 2 digits (e.g. "00", "11", "99")
      );
      if (invalidNumbers.length > 0) {
        alert(`Please enter only 2-digit numbers for Jodi`);
        return;
      }
    }
    if (betTime === "open" && isOpenSuspend === 1) {
      alert("Open betting is suspended for this match.");
      return;
    }
    if (betTime === "close" && isCloseSuspend === 1) {
      alert("Close betting is suspended for this match.");
      return;
    }

    let betOk = checkOpenCloseBet();
    if (!betOk) {
      // alert("Unable to place this bet");
      openModalWithMessage("Unable to place Bet");
      return;
    }
    // else {
    //   alert("can place bet");
    //   return;
    // }
    // let betOk = true;
    if (betOk === true) {
      // const totalStake = selectedDigits.reduce((sum, d) => sum + parseInt(d.stake || 0), 0);
      // const totalStake = digitStakes.reduce(
      //   (sum, digit) => sum + (digitStakes[digit] || 0),
      //   0
      // );
      const totalStake = Object.values(digitStakes).reduce((a, b) => a + b, 0);

      // alert(totalStake);
      // return;
      // const stake = parseInt(stakeInput);
      // if (
      //   mergedArray.length === 0 ||
      //   isNaN(stake) ||
      //   stake < minMaxMap[selectedType]?.min_stake ||
      //   stake > minMaxMap[selectedType]?.max_stake
      // ) {
      //   alert(
      //     "Select digit(s) and enter a valid stake (" +
      //       minMaxMap[selectedType]?.min_stake +
      //       " – " +
      //       minMaxMap[selectedType]?.max_stake +
      //       ")"
      //   );
      //   return;
      // }
      const newEntry = {
        digits: Object.keys(digitStakes), // ['1', '2', '3', '4']
        digitStakes: { ...digitStakes }, // full map of digit → stake
        rate: selectedRate,
        type: betType,
        time: betTime,
      };
      // let amount = mergedArray.length * stake;
      // if (amount > balance) {
      //   alert("Insufficient Fund, Unable to place bet!");
      //   return;
      // }
      setBetHistory((prev) => [...prev, newEntry]);
      // updateBalance(totalStake);
      // updateExposure(totalStake);
      // const categoryArray = DIGITS_MAP[betType + "_" + betTime];
      // addMissingValues(categoryArray, mergedArray);
      // setLoading(true);
      const updatedBetHistory = [...betHistory, newEntry];
      const results = calculateResults(updatedBetHistory);
      console.log(results);
      const userIP = await getUserIP();
      const TYPE_ID_MAP = {
        single: 1,
        singlePatti: 2,
        doublePatti: 3,
        tripplePatti: 4,
        jodi: 5,
      };
      const TIME_TYPE_MAP = {
        open: 0,
        close: 1,
      };
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
      const urlencoded = {
        match_id: match_id,
        digit: digitStakes,
        // stake: stake,
        // digitStakes:
        rate: selectedRate,
        type_name: betType,
        type_id: TYPE_ID_MAP[betType],
        time: betTime,
        is_closed_type: TIME_TYPE_MAP[betTime],
        user_id: localStorage.getItem("uid"),
        status_id: 1,
        ip: userIP,
        results: results,
        amount: totalStake,
      };
      let requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(urlencoded),
      };
      fetch(process.env.REACT_APP_API_HOST + "/bet/save", requestOptions)
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.success) {
            setTimeout(() => {
              setLoading(false);
            }, 1000);
            getUserBetsLog();
          } else {
            console.error("Error saving bet:", result.message);
          }
        })
        .catch((err) => {
          console.error("Error saving bet:", err);
        });
      setSelectedDigits([]);
      setStakeInput(0);
      setDigitStakes({});
      setSelectedStake(0);
    }
  };

  const calculateResults = (history = betHistory) => {
    const digitStakeMap = {};
    let totalStake = 0;

    let getdigitOps = DIGITS_MAP[betType + "_" + betTime];
    getdigitOps.forEach((digit) => {
      digitStakeMap[digit] = 0;
    });

    history
      .filter((entry) => entry.type === betType && entry.time === betTime)
      .forEach(({ digitStakes }) => {
        for (const [digit, stake] of Object.entries(digitStakes)) {
          totalStake += parseInt(stake);
          digitStakeMap[digit] += parseInt(stake);
        }
      });

    const results = {};
    getdigitOps.forEach((digit) => {
      const stake = digitStakeMap[digit];
      results[digit] =
        stake > 0 ? stake * selectedRate - totalStake : -totalStake;
    });

    return results;
  };

  const results = calculateResults();
  const renderComponent = () => {
    switch (betType) {
      case "jodi":
        return (
          <Jodi
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
          />
        );
      case "tripplePatti":
        return (
          <TriplePatti
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
          />
        );
      case "doublePatti":
        return (
          <DoublePatti
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
          />
        );
      case "singlePatti":
        return (
          <SinglePatti
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
          />
        );
      case "single":
        return (
          <Single
            customDigits={customDigits}
            setCustomDigits={setCustomDigits}
            handleCustomInput={handleCustomInput}
            results={results}
            stakeInput={stakeInput}
            setStakeInput={setStakeInput}
            selectedDigits={selectedDigits}
            setSelectedDigits={setSelectedDigits}
            randomCount={randomCount}
            setRandomCount={setRandomCount}
            handleDigitToggle={handleDigitToggle}
            minMaxMap={minMaxMap}
            selectedType={selectedType}
            MAX_SELECTION_VALUE={MAX_SELECTION_VALUE}
            betType={betType}
            betTime={betTime}
            DIGITS_MAP={DIGITS_MAP}
            digitOptions={digitOptions}
            handleSubmit={handleSubmit}
            setGuruSelected={setGuruSelected}
            selectedStake={selectedStake}
            digitStakes={digitStakes}
            setDigitStakes={setDigitStakes}
            lastSelectedDigit={lastSelectedDigit}
            setLastSelectedDigit={setLastSelectedDigit}
          />
        );
      default:
        return null;
    }
  };
  const formatDateTime = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const getSelection = (selection) => {
    switch (selection) {
      case 1:
        return "Single";
      case 2:
        return "Single Patti";
      case 3:
        return "Double Patti";
      case 4:
        return "Triple Patti";
      case 5:
        return "Jodi";
      default:
        return "Invalid selection";
    }
  };
  if (loading) {
    return (
      <div className="h-screen">
        <Header />
        <div className="flex items-center justify-center min-h-screen">
          <Spinner size="lg" variant="spinner" color="warning" />
        </div>
      </div>
    );
  }
  return (
    <div>
      <Header />

      <div className="shadow-lg sm:border border-gray-300 -mt-1 md:mt-7 bg-white rounded-b-lg sm:p-0 pt-0  w-full max-w-5xl mx-auto my-6">
        <div className="px-0 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-xl lg:py-0">
          <section className="md:py-0 py-4">
            <div className="container mx-auto">
              {/* <div className="border-b border-m_black">
                <div className="flex items-center gap-4 p-2">
                  <div className="flex gap-1 text-start">
                    <div className="w-8 h-8 border-l-4 border-m_green">
                      <img
                        src="/img/madhur.png"
                        alt="matka-icon"
                        loading="lazy"
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <h5 className="text-lg font-semibold text-center text-gray-800">
                      {marketName || ""}
                    </h5>
                  </div>
                </div>
              </div> */}
            </div>

            <div className=" w-full ">
              <Tabs
                key="underlined"
                variant="light"
                className="w-full"
                classNames={{
                  base: "w-full bg-matka_black",
                  tabList: "gap-4 relative p-1",
                  tab: "h-9 px-3 py-1 text-center text-md text-white  data-[selected=true]:rounded",
                  cursor: "bg-m_text1",
                  panel: "mt-0",
                  tabContent: "text-white px-2 w-full h-full",
                }}
                selectedKey={selectedTab}
                onSelectionChange={setSelectedTab}
              >
                <Tab key="photos" title={marketName || "SRIDEVII"}>
                  <div className="w-full !p-0 !m-0">
                    <HeaderSection
                      // formatDateToDDMMYYYY={formatDateToDDMMYYYY}
                      selectedMarketKey={selectedMarketKey}
                      setSelectedMarketKey={setSelectedMarketKey}
                      isOpenSuspend={isOpenSuspend}
                      isCloseSuspend={isCloseSuspend}
                      draw_date={draw_date}
                      markets={markets}
                      betTypes={betTypes}
                      betType={betType}
                      setBetType={setBetType}
                      setBetTime={setBetTime}
                      setSelectedDigits={setSelectedDigits}
                      setStakeInput={setStakeInput}
                      setBetHistory={setBetHistory}
                      setRandomCount={setRandomCount}
                      DIGITS_MAP={DIGITS_MAP}
                      rateMap={rateMap}
                      setDigitOptions={setDigitOptions}
                      selectedRate={selectedRate}
                      setSelectedRate={setSelectedRate}
                      selectedType={selectedType}
                      setSelectedType={setSelectedType}
                      minMaxMap={minMaxMap}
                      setMinMaxMap={setMinMaxMap}
                      selectedMinMax={selectedMinMax}
                      setSelectedMinMax={setSelectedMinMax}
                      setDigitStakes={setDigitStakes}
                      setSelectedStake={setSelectedStake}
                      setLastSelectedDigit={setLastSelectedDigit}
                      betTime={betTime}
                    />
                  </div>
                  <div className="w-full !p-0 m-0 mt-3">
                    <Stake
                      selectedStake={selectedStake}
                      setSelectedStake={setSelectedStake}
                      stakeInput={stakeInput}
                      setStakeInput={setStakeInput}
                      minMaxMap={minMaxMap}
                      selectedType={selectedType}
                    />
                  </div>

                  <div id="main-card1" className="mt-1">
                    {renderComponent()}
                  </div>
                </Tab>
                <Tab
                  key="music"
                  title="BETS"
                  color="primary"
                  className="data-[state=active]:text-primary"
                >
                  <div className="container mx-auto px-4 py-3">
                    {/* <div className="text-center mb-6">
                      <h3 className="text-xl font-bold text-gray-800">
                        Bet History
                      </h3>
                    </div> */}
                    {betsLog.map((row, index) => (
                      <Card
                        className="shadow-xl border border-gray-400 mb-3"
                        radius="sm"
                      >
                        <CardBody className="p-4">
                          <div className="absolute left-0 top-0 bg-m_peach text-white text-center text-sm px-1.5 py-0.5 w-36 z-10 mb-2">
                            {getSelection(row.match_map_id)}
                          </div>

                          <div className="text-sm font-semibold text-m_red mb-2 mt-4">
                            {row.name}{" "}
                            {row.is_closed_type.data[0] === 0
                              ? "OPEN"
                              : "CLOSE"}{" "}
                            -{" "}
                            <span className="text-xs px-1 italic">
                              {formatDateTime(row.created_on)}
                            </span>
                          </div>

                          <div className="grid grid-cols-3 gap-y-2 text-sm text-m_black">
                            <div>
                              <span className="text-sm text-m_black font-medium">
                                Digit :{" "}
                              </span>
                              <span className="text-xs">{row.digit}</span>
                            </div>
                            <div>
                              <span className="text-sm text-m_black font-medium">
                                Stake :{" "}
                              </span>
                              <span className="text-xs">{row.stake}</span>
                            </div>
                            <div>
                              <span className="text-sm text-m_black font-medium">
                                P & L :{" "}
                              </span>
                              <span className="text-xs">
                                {row.stake * row.rate}
                              </span>
                            </div>
                            {/* <div>
                              <span className="text-sm text-m_black font-medium">
                                Rate fff :{" "}
                              </span>
                              <span className="text-xs">{row.win} DFDF</span>
                            </div> */}
                          </div>
                          {row.time === "open" ? (
                            !row.open_result || row.open_result === "" ? (
                              <p className="text-red-500 text-sm italic text-center">
                                Pending, Wait for Open Result
                              </p>
                            ) : row.win === 1 ? (
                              <p className="text-green-600 text-sm italic text-center">
                                Win, Congratulations.
                              </p>
                            ) : row.win === 0 ? (
                              <p className="text-red-500 text-sm italic text-center">
                                Lose, Please try again.
                              </p>
                            ) : null
                          ) : row.time === "close" ? (
                            !row.close_result || row.close_result === "" ? (
                              <p className="text-red-500 text-sm italic text-center">
                                Pending, Wait for Close Result
                              </p>
                            ) : row.win === 1 ? (
                              <p className="text-green-600 text-sm italic text-center">
                                Win, Congratulations.
                              </p>
                            ) : row.win === 0 ? (
                              <p className="text-red-500 text-sm italic text-center">
                                Lose, Please try again.
                              </p>
                            ) : null
                          ) : null}
                        </CardBody>
                      </Card>
                    ))}
                    {/* 
                    <Card className="shadow-md border border-gray-200 mb-6">
                      <CardBody className="p-4">
                        <div className="absolute left-4 top-0 bg-m_peach text-white text-center text-sm px-1.5 py-0.5 rounded-b-md w-36 z-10 mb-2">
                          single_patti
                        </div>

                        <div className="text-md font-semibold text-m_red mb-3 mt-3">
                          MAIN BAZAR OPEN
                        </div>

                        <div className="grid grid-cols-2 gap-y-2 text-sm text-m_black">
                          <div>
                            <span className="text-sm text-m_black font-medium">
                              Play On :{" "}
                            </span>
                            <span className="text-xs">
                              09/07/2025 (Wednesday)
                            </span>
                          </div>
                          <div>
                            <span className="text-sm text-m_black font-medium">
                              Play For :{" "}
                            </span>
                            <span className="text-xs">
                              09/07/2025 (Wednesday)
                            </span>
                          </div>
                          <div>
                            <span className="text-sm text-m_black font-medium">
                              Digit :{" "}
                            </span>
                            <span className="text-xs">357</span>
                          </div>
                          <div>
                            <span className="text-sm text-m_black font-medium">
                              Points :{" "}
                            </span>
                            <span className="text-xs">50.00</span>
                          </div>
                          <div>
                            <span className="text-xs text-m_black font-medium">
                              Bid ID :{" "}
                            </span>
                            <span className="text-xs">74985469</span>
                          </div>
                          <div>
                            <span className="text-xs text-m_black font-medium">
                              Bid Time :{" "}
                            </span>
                            <span className="text-xs">09/07/2025 06:05 PM</span>
                          </div>
                        </div>

                        <p className="mt-4 text-sm text-red-500 flex justify-center gap-1">
                          <p className="w-4 h-4" />
                          Lose, Please try again.
                        </p>
                      </CardBody>
                    </Card> */}
                  </div>
                </Tab>
      
              </Tabs>
            </div>
          </section>

          <Modal
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            classNames={{
              backdrop: "bg-black/15",
            }}
          >
            <ModalContent>
              {(onClose) => (
                <>
                  {/* <ModalHeader className="flex flex-col gap-1">
                    {" "}
                    Title
                  </ModalHeader> */}
                  <ModalBody>
                    <p>{modalMessage}</p>
                  </ModalBody>
                  <ModalFooter></ModalFooter>
                </>
              )}
            </ModalContent>
          </Modal>
        </div>
      </div>
    </div>
  );
};
export default GameDetailPage;
